import logo from './logo.svg';
import './App.css';
import Header from './components/Header/Header.js'
import Body from './components/Body/Body';

function App() {
  return (
    <div className="App">
        <Header></Header>
        <Body></Body>
    </div>
  );
}

export default App;
